import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';

class RejectProbationModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'reject-probation-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#reject-probation-modal {
          --modal-min-width: 25%;
          --modal-max-width: 600px;
        }
        h3 {
          margin: 0;
        }
      </style>

      <h3 slot="title">Reject Probation</h3>

      <p>Please provide the reason you are rejecting this probation.</p>
      <bn-action
        .href="${this.href}"
        buttonstyle='outlinedError'
        suppressheader
        actionname="reject"
        submittext="Reject"
        @response="${this._onResponse}"
      ></bn-action>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));
    this.close();
  }
}

window.customElements.define('reject-probation-modal', RejectProbationModal);
